'use strict';
var angular = require('angular');

var actionTaskCtrl = ['Department', '$state', 'Client', 'Member', '$scope', 'BuilderDataService', function (Department, $state, Client, Member, $scope, BuilderDataService) {
    var _this = this;
    this.taskBis = JSON.parse(JSON.stringify(this.task)); // For initial values, if it's edit, we need to keep the original data
    this.selectedForm = null;
    this.selectedClient = null;
    this.selectedMembers = [];
    this.datePopup = false;
    this.endDatePopup = false;
    $state.template = undefined;
    this.listfields = [];
    this.membersSelected = [];

    this.dateList = [{ id: 1, name: 'Today'}];
    this.startList = [{ id: 2, name: '10:00'}];
    this.endList = [{ id: 3, name: '11:00'}];

    // If the task is not new, we add important data
    if (this.task && this.task.name !== null && this.task.name !== '') {
        this.selectedTemplate = this.task.name;

        // LO SIGUIENTE SE HACE DENTRO DE LAS FUNCIONES QUE CARGAN LOS LISTADOS DE FORM Y SITE
        // this.selectedForm = this.task.form || null; 
        // this.selectedClient = this.task.client || null;
        // this.selectedMembers = angular.copy(this.task.member);    
        // this.listfields = this.selectedForm.pages.flatMap(page=>page.fields.filter(f=>!["docs","title","photo","video","sign","autonumeric","group"].includes(f.type)));

        delete this.task.tenantId;
    } else {
      // "For a new task, the team members' list is loaded, and the list of members is retrieved from local storage.
      // If they are selected (hide === false), they are assigned to selectedMembers to appear pre-selected in the form."
    //   this.getMembersNew();
    }

    function validateTask(task) {
        //if anything is missing we return
        // console.log(task.name, task.formId, task.date, task.startHour, task.endHour, task.clientId)
        // console.log('task.name, task.formId, task.clientId', task.name, task.formId, task.clientId)
        if (!task.name || !task.formId || !task.clientId) {
            return false;
        }
        return true;
    }

    this.getForms = function (value, init) {
        let query = {
            id: $state.params.departmentId
        };

        if (value) {
            query.filter = {
                where: {
                    name: {
                        regexp: '/^' + value + '/i'
                    }
                }
            };
        }
        return Department.forms(query)
            .$promise
            .then(function (forms) {
                if (init && _this.taskBis && _this.taskBis.formId && _this.taskBis.formId !== '') {
                    _this.selectedForm = null;
                    let selectedForm = forms.find((form) => {
                        return form.id === _this.taskBis.formId;
                    })
                    if (selectedForm) {
                        _this.selectedForm = selectedForm;
                        _this.task.formId = _this.taskBis.formId;
                        _this.listfields = _this.selectedForm.pages.flatMap(page=>page.fields.filter(f=>!["docs","title","photo","video","sign","autonumeric","group"].includes(f.type)));
                    }
                }

                return forms;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.getTemplates = function (value) {
        let query = {
            id: $state.params.departmentId,
            filter: { include: 'form' }
        };

        if (value) {
            query.filter.where = {
                name: {
                    regexp: '/^' + value + '/i'
                }
            };
        }

        return Department.tasktemplate(query)
            .$promise
            .then(function (forms) {
                // console.log('TEMPLATES', forms);
                return forms;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.getClients = function (value, init) {
        let query = {};

        if (value) {
            query.filter = {
                where: {
                    name: {
                        regexp: '/^' + value + '/i'
                    }
                }
            };
        }
        return Client.find(query)
            .$promise
            .then(function (clients) {
                // For initial values, if it's edit:
                if (init && _this.taskBis && _this.taskBis.clientId && _this.taskBis.clientId !== '') {
                    _this.selectedClient = null;
                    let selectedClient = clients.find((client) => {
                        return client.id === _this.taskBis.clientId;
                    })
                    if (selectedClient) {
                        _this.selectedClient = selectedClient;
                        _this.task.clientId = _this.taskBis.clientId;
                    }
                }
                return clients;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.formSelected = function (form) {
        // console.log('form selected', form);
        this.task.formId = form.id;
        this.listfields = form.pages.flatMap(page=>page.fields.filter(f=>!["docs","title","photo","video","sign","autonumeric","group"].includes(f.type)));
    };

    this.useTemplate = function (template, model, label) {
        // console.log('template selected', template);
        
        if (!template.id) {
            this.task.name = template;
            return;
        }
        $state.template = template;

        this.task.name = template.name;
        this.task.description = template.description;
        this.task.formId = template.formId;
        this.selectedForm = template.form;
        
        if (this.selectedForm) {
            this.listfields = this.selectedForm.pages.flatMap(page=>page.fields.filter(f=>!["docs","title","photo","video","sign","autonumeric","group"].includes(f.type)));
        }
        
        this.task.payload = [];
        if (template.payloadHidden == undefined) {
            template.payloadHidden = {};
        }

        // The old data type (strings) is converted to the new one (object)
        template.payload = template.payload.map((item) => {
            // console.log('payload map item', item)
            if (typeof item === 'string') {
                return {
                    key: item,
                    value: null,
                    valueConstant: null,
                    fieldId: null,
                    id: Math.random().toString(36).substr(2, 9),
                    hidden: false,
                }
            } else {
                // console.log('item.constantChecked', item.constantChecked);
                // To adapt old data to new data.
                return {
                    key: item.key,
                    value: item.value ? item.value : null,
                    valueConstant: (item.value !== undefined && item.value !== null && item.value !== '' && item.valueConstant === undefined) ?
                        true : (item.valueConstant || false),
                    hidden: item.hidden === undefined ?
                        (template.payloadHidden[item.key] !== undefined ? template.payloadHidden[item.key] : false) :
                            (item.hidden || false),
                    fieldId: item.fieldId || null,
                    id: item.id,
                }
            }
        });

        // console.log('_this.task berofe forEach', _this.task)

        template.payload.forEach(function (field) {
            _this.task.payload.push(field);
        });

        // console.log('_this.task after forEach', _this.task)
        // console.log('TEMPLATE PROCESADO', template);
    };

    this.clientSelected = function (client) {
        this.task.clientId = client.id;
    };

    // Watchers
    $scope.$watch(function () {
        return _this.task;
    }, function () {
        _this.taskValidation = validateTask(_this.task);
    }, true);

    $scope.$watch(function () {
        return _this.selectedTemplate;
    }, function () {
        if (_this.selectedTemplate && !_this.selectedTemplate.id) {
            _this.task.name = _this.selectedTemplate;
        }
        if (!_this.selectedTemplate) {
            _this.task.name = null;
        }
    }, true);

    $scope.$watch(function () {
        return _this.selectedClient;
    }, function () {
        if (!_this.selectedClient) {
            _this.task.clientId = null;
        }
        _this.taskValidation = validateTask(_this.task);
    }, true);

    $scope.$watch(function () {
        return _this.selectedForm;
    }, function () {
        if (!_this.selectedForm) {
            _this.task.formId = null;
        }
        _this.taskValidation = validateTask(_this.task);
    }, true);

    this.changeDateCheckbox = function(checkbox) {
        if (checkbox === 'allDay' && _this.task.allDay) {
            _this.task.noExpiration = false;
            _this.task.startHour = null;
            _this.task.endHour = null;
        } else if (checkbox === 'noExpiration' && _this.task.noExpiration) {
            _this.task.allDay = false;
            _this.task.startHour = null;
            _this.task.endHour = null;
        }
    }

    this.getInputElements = function () {
        let elements = [];
        elements = BuilderDataService.getElements(null, _this.element);

        return elements.filter(function (element) {
            if (element.id === _this.element.id) {
                return false;
            }
            switch (element.type) {
                case "text":
                case "select":
                case "formula":
                case "number":
                case "checkbox":
                case "multiple":
                case "date":
                case "timestamp":
                case "qr":
                    return true;
                default:
                    return false;
            }
        });
    }

    this.valueElements = _this.getInputElements();

    _this.getClients(false, true);
    _this.getForms(false, true);
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            task: '=',
            taskValidation: '=',
            element: '='
        },
        controller: actionTaskCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/formConfig/actionTaskDirective.html'
    };
};
